import { memo } from "react";
import { Skeleton } from "@/components/ui/skeleton";

export const PublicLinksSkeleton = memo(function PublicLinksSkeleton() {
  return (
    <div className="min-h-screen bg-linear-to-br from-gray-50 via-blue-50/30 to-purple-50/30">
      <div className="absolute inset-0 z-0 overflow-hidden opacity-20">
        <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-blue-200 blur-3xl" />
        <div className="absolute -bottom-32 -left-32 h-96 w-96 rounded-full bg-purple-200 blur-3xl" />
      </div>

      <div className="relative z-10 container mx-auto px-4 py-5 pb-8 sm:py-8 sm:pb-10 lg:w-2/3 xl:w-1/2">
        <div className="mb-5 text-center sm:mb-7">
          <div className="mb-3 flex justify-center sm:mb-4">
            <Skeleton variant="shimmer" className="h-12 w-12 rounded-2xl sm:h-14 sm:w-14" />
          </div>
          <Skeleton variant="shimmer" className="mx-auto h-8 w-56 rounded-xl sm:h-10 sm:w-72" />
        </div>

        <div className="mx-auto mb-6 flex max-w-sm items-center rounded-full border border-black/5 bg-white/55 p-1 shadow-sm backdrop-blur-md sm:mb-7">
          <Skeleton variant="shimmer" className="h-10 flex-1 rounded-full" />
          <span className="mx-1 h-5 w-px shrink-0 bg-black/10" aria-hidden />
          <Skeleton variant="shimmer" className="h-10 flex-1 rounded-full" />
        </div>

        <div className="mb-8 space-y-2.5 sm:mb-10 sm:space-y-3">
          {Array.from({ length: 5 }).map((_, index) => (
            <Skeleton
              key={index}
              variant="shimmer"
              className="h-14 w-full rounded-2xl sm:h-16"
            />
          ))}
        </div>

        <div className="flex flex-col items-center gap-3">
          <div className="flex items-center gap-4">
            <Skeleton variant="shimmer" className="h-9 w-9 rounded-full" />
            <Skeleton variant="shimmer" className="h-9 w-9 rounded-full" />
          </div>
          <Skeleton variant="shimmer" className="h-6 w-24 rounded-md" />
        </div>
      </div>
    </div>
  );
});
